module.exports = __webpack_public_path__ + "img/zaixianchongzhi.6d42fe53.png";